import React from 'react';
import { List } from 'antd';
import { CheckListItem } from './Item';

export const CheckList = (props) => {
  const { value, field } = props;
  const { config, raw } = field;
  const { configs } = config || {};

  return (
    <List
      dataSource={value}
      renderItem={(itemFields, index) => {
        return <CheckListItem fields={itemFields} configs={configs} ordinal={index + 1} />;
      }}
    />
  );
};
